import MediaGallery from "./MediaGallery";
import { addCampaignImage, deletCampaignImage, getCampaings } from "firestoreService";

const Campaigns = () => (
  <MediaGallery
    title="Campaigns"
    description="Campaign photos published on the public Campaign page."
    itemNoun="Campaign"
    fetchAll={getCampaings}
    addImage={addCampaignImage}
    removeImage={deletCampaignImage}
  />
);

export default Campaigns;
